import { FC, ReactNode, useState } from 'react';
import { Card, CardProps } from '@mui/material';
import { CollapsibleCardContext } from './CollapsibleCardContext';

interface CollapsibleCardProps extends CardProps {
    defaultExpanded?: boolean;
    children: ReactNode;
}

const CollapsibleCard: FC<CollapsibleCardProps> = ({ defaultExpanded = false, children, ...props }) => {
    const [expanded, setExpanded] = useState(defaultExpanded);
    const toggle = () => setExpanded((prev) => !prev);

    return (
        <CollapsibleCardContext.Provider value={{ expanded, toggle }}>
            <Card variant="outlined" {...props}>
                {children}
            </Card>
        </CollapsibleCardContext.Provider>
    );
};

export type { CollapsibleCardProps };
export default CollapsibleCard;
